import { createAction } from '@'
import { $formValues } from '../stores'

export default createAction('SetFormValues', (name, values) => {
    $formValues.subStore(name).setState(typeof values === 'function' ? values : () => values)
})
